import { schema } from 'normalizr';

const pulseScaleSchema = new schema.Entity('pulseScales', {});

export default pulseScaleSchema;
